"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../../../gen-src/Localize");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
function createServerOrPathString(database) {
    switch (database.__typename) {
        case 'CloudFile':
            return database.requestUrl ? database.requestUrl : database.provider + " " + database.fileId;
        case 'DatabaseServer':
            return Localize_1.Messages.DatabaseWithHostname({
                databaseName: database.name !== null ? database.name : Localize_1.Messages.PermissionsRequired(),
                databaseHostName: database.hostName !== null ? database.hostName : Localize_1.Messages.PermissionsRequired()
            });
        case 'File':
            return database.filePath !== null ? database.filePath : Localize_1.Messages.PermissionsRequired();
        case 'WebDataConnector':
            return database.connectorUrl !== null ? database.connectorUrl : Localize_1.Messages.PermissionsRequired();
        default:
            TypescriptHelpers_1.assertUnreachable(database);
            return '';
    }
}
exports.createServerOrPathString = createServerOrPathString;
//# sourceMappingURL=ServerOrPathCell.js.map